export const PATIENT_REFILL_ROUTE = '/patient/refill' as const;
export const PATIENT_ORDERS_ROUTE = '/patient/orders' as const;

/** @deprecated Only used as a redirect target to go to PRESCRIPTIONS_ROUTE remove this route after no longer hit in analytics */
export const DEPRECATED_PATIENT_PRESCRIPTION_ROUTE = '/patient/prescription' as const;
/** @deprecated Only used as a redirect target to go to PRESCRIPTIONS_ROUTE remove this route after no longer hit in analytics */
export const DEPRECATED_PRESCRIPTION_ROUTE = '/prescription' as const;
/** @deprecated Only used as a redirect target to go to PRESCRIPTIONS_ROUTE don't remove this unless customer-portal stops using this path */
export const UNUSED_PRESCRIPTION_ROUTE = '/prescription/:id' as const;
export const PRESCRIPTIONS_ROUTE = '/prescriptions' as const;

export const PROFILE_DETAILS_ROUTE = '/profile-detail' as const;

export const HOME_ROUTE = '/home' as const;

export const LOGIN_ROUTE = '/login' as const;
export const LOGIN_ONBOARDKEY_ROUTE = '/login/:onBoardKey' as const;
export const LOGIN_PATIENT_ONBOARDKEY_ROUTE = '/login/patient/:onBoardKey' as const;
export const LOGIN_PATIENT_ONBOARDKEY_PATH = '/login/patient/' as const;

export const LOGOUT_ROUTE = '/logout' as const;

export const FORGOT_PASSWORD_ROUTE = '/forgot-password' as const;
export const RESET_PASSWORD_ROUTE = '/reset-password' as const;
export const RESET_PASSWORD_LEGACY_ROUTE = '/reset-password/:id' as const;

export const POLICY_ROUTE = '/policy' as const;

export const FAQ_ROUTE = '/faq' as const;

export const HEALTH_CHECK_ROUTE = '/health-check' as const;

export const MEDICINE_INFORMATION_ROUTE = '/medicine-information' as const;

export const PRODUCT_DETAIL_PATH = '/product-detail/' as const;
export const PRODUCT_DETAIL_ROUTE = '/product-detail/:id' as const;

export const CONSULTATIONS_ROUTE = '/consultations' as const;

export const PRE_CONSULT_ROUTE = '/pre-consult/:token?' as const;

const ALTERNALEAF_MARKETING_HOME = 'https://www.alternaleaf.com.au';

export const ALTERNALEAF_MARKETING = {
  HOME: ALTERNALEAF_MARKETING_HOME,
  PRIVACY_POLICY: `${ALTERNALEAF_MARKETING_HOME}/privacy`,
} as const;
